const initialState = {
  counter: 0,
  preferences: {},
  isLoading: false,
};

export default initialState;
